import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { api } from '@/redux/api';
import { useFacilityId } from './use-facilityid';

/**
 * 判断当前登录用户是否是认证任务的接收者（certify_by）
 * @returns {Object} { isAssignTo: boolean, loading: boolean, taskInfo: Object|null }
 */
export const useIsAssignTo = () => {
    const [isAssignTo, setIsAssignTo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [taskInfo, setTaskInfo] = useState(null);

    // 获取当前设施ID
    const facilityId = useFacilityId();
    
    // 从Redux获取当前登录用户信息
    const currentUserId = useSelector(state => state.Auth.userId);
    useEffect(() => {
        // 如果没有facilityId或当前用户ID，则不执行查询
        if (!facilityId || !currentUserId) {
            setIsAssignTo(false);
            setLoading(false);
            setTaskInfo(null);
            return;
        }

        const checkIsAssignTo = async () => {
            setLoading(true);

            try {
                // 第一步：获取认证请求基本信息
                const certifyRequest = await api.getCertifyRequestsById(facilityId);
                
                if (!certifyRequest || !certifyRequest.id) {
                    // 没有找到认证任务
                    setIsAssignTo(false);
                    setTaskInfo(null);
                    return;
                }

                // 第二步：获取认证任务详细信息和日志
                const certifyLogs = await api.getCertifyLogs(certifyRequest.id);
                
                if (!certifyLogs || !certifyLogs.task) {
                    setIsAssignTo(false);
                    setTaskInfo(null);
                    return;
                }

                const task = certifyLogs.task;
                setTaskInfo(task);

                // 判断当前用户是否是任务接收者
                const isCurrentUserAssignTo = task.certify_by?.user_id === currentUserId;
                setIsAssignTo(isCurrentUserAssignTo);

            } catch (err) {
                console.error('Error checking assign to status:', err);
                setIsAssignTo(false);
                setTaskInfo(null);
            } finally {
                setLoading(false);
            }
        };

        checkIsAssignTo();
    }, [facilityId, currentUserId]);

    return {
        isAssignTo,
        loading,
        taskInfo
    };
};

